export default {
  getTimetableSlotsOfAFaculty: '/timetable/getTimetableSlotsOfAFaculty'
}
